export default __webpack_public_path__ + "static/media/lombard_street.a7d12d9b.jpg";